"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.priceGraph = void 0;
exports.priceGraph = function (currency) {
    switch (currency) {
        case "USD":
        case "CAD":
        case "CLP":
        case "NZD":
        case "ARS":
        case "COP":
            return "$";
        case "MXN":
            return "$";
        case "AUD":
            return "$";
        case "HKD":
            return "$";
        case "CNY":
        case "JPY":
            return "￥";
        case "EUR":
            return "€";
        case "GBP":
        case "EGP":
            return "£";
        case "CHF":
            return "₣";
        case "RUB":
            return "p.";
        case "BRL":
            return "R$";
        case "NOK":
        case "DKK":
            return "kr.";
        case "SEK":
            return "Kr.";
        case "KRW":
            return "₩";
        case "ILS":
            return "₪";
        case "SGD":
            return "S$";
        case "INR":
            return "Rs";
        case "CZK":
            return "Kč";
        case "PLN":
            return "zł";
        case "JOD":
            return "JD";
        case "THB":
            return "฿";
        case "ZAR":
            return "R";
        default:
            return "";
    }
};
